import type { GrammarExplanationBlock } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';

interface Props {
  block: GrammarExplanationBlock;
  index: number;
  pageNumber: number;
}

export function GrammarExplanationPreview({ block, index, pageNumber }: Props) {
  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      {/* Rule explanation */}
      <div className="wb-grammar-rule-box">
        <div className="wb-grammar-topic">{block.topic}</div>
        <p className="wb-grammar-explanation">{block.explanation}</p>
        {block.pattern && <div className="wb-grammar-pattern">{block.pattern}</div>}
      </div>

      {/* Examples table */}
      <div className="wb-grammar-examples">
        <div className="wb-grammar-section-label">Examples</div>
        <table className="wb-grammar-examples-table">
          <thead>
            <tr>
              <th>Target</th>
              <th>Native</th>
            </tr>
          </thead>
          <tbody>
            {block.examples.map((ex, i) => (
              <tr key={i}>
                <td>{ex.target}</td>
                <td className="wb-native-tag">{ex.native}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Common mistakes */}
      <div className="wb-grammar-mistakes">
        <div className="wb-grammar-section-label">Common mistakes</div>
        <ul>
          {block.commonMistakes.map((mistake, i) => (
            <li key={i}>{mistake}</li>
          ))}
        </ul>
      </div>

      {/* Practice */}
      <div className="wb-grammar-practice">
        <div className="wb-grammar-section-label">Quick practice</div>
        {block.practice.map((item, i) => (
          <div key={i} className="wb-grammar-practice-item">
            <p className="wb-fill-text">
              <span className="wb-fill-number">{i + 1}</span>
              {item.question}
            </p>
            <div className="wb-fill-hint">
              <span className="wb-native-tag">{item.hint}</span>
            </div>
          </div>
        ))}
      </div>

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
